import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from './pages/Start.vue'
import Email from './pages/Email.vue'
import Userdata from './pages/Userdata.vue'
import Domain from './pages/Domain.vue'
import VerifyEmail from './pages/VerifyEmail.vue'
import CreateAccount from './pages/CreateAccount.vue'
import Success from './pages/Success.vue'

let initialized = false

export default function () {
  if (initialized) return

  Vue.use(VueRouter)

  const routes = [
    { path: '/', redirect: '/start' },
    { path: '/start', name: 'start', component: Start },
    { path: '/email', name: 'email', component: Email },
    { path: '/userdata', name: 'userdata', component: Userdata },
    { path: '/domain', name: 'domain', component: Domain },
    { path: '/verify_email', name: 'verify_email', component: VerifyEmail },
    { path: '/create_account', name: 'create_account', component: CreateAccount },
    { path: '/success', name: 'success', component: Success }
  ]

  const router = new VueRouter({ routes })
  Vue.mixin({ router })

  initialized = true
}
